import useAuth from "@hooks/use-auth";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, redirectUrl }: { children: ReactElement; redirectUrl: string }) {
  const { user, emailUser } = useAuth();
  return !!user || !!emailUser ? children : <Navigate to={redirectUrl} />;
}
